import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import MenuPage from "./pages/MenuPage";
import AuthGuard from "./components/AuthGuard";

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-soft-pink via-soft-yellow to-soft-blue">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/menu" element={<MenuPage />} />
          <Route path="/admin" element={<AuthGuard />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
